/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.getAuthorFeed'

export { $nsid }

/** Get a view of an actor's 'author feed' (post and reposts by the author). Does not require auth. */
const main = l.query(
  $nsid,
  l.params({
    actor: l.string({ format: 'at-identifier' }),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
    filter: l.optional(
      l.withDefault(
        l.string<{
          knownValues: [
            'posts_with_replies',
            'posts_no_replies',
            'posts_with_media',
            'posts_and_author_threads',
            'posts_with_video',
          ]
        }>(),
        'posts_with_replies',
      ),
    ),
    includePins: l.optional(l.withDefault(l.boolean(), false)),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    feed: l.array(
      l.ref<FeedDefs.FeedViewPost>((() => FeedDefs.feedViewPost) as any),
    ),
  }),
  ['BlockedActor', 'BlockedByActor'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
